import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAndelaComponent } from './simple-icons-andela.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAndelaComponent ],
    exports:      [ SimpleIconsAndelaComponent ],
    bootstrap:    []
})
export class SimpleIconsAndelaModule {}
